import { render, staticRenderFns } from "./ConsultasPreNatal.vue?vue&type=template&id=faaf6a98"
import script from "./ConsultasPreNatal.vue?vue&type=script&lang=js"
export * from "./ConsultasPreNatal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports